import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { SideNavMenuComponent } from './side-nav-menu/side-nav-menu.component';
import { LocalStorageService } from '../services/local-storage.service';

export interface IMenuItem {
    icon?: string;
    label: string;
    route?: string;
    subItems?: IMenuItem[];
}

@Component({
    selector: 'custom-side-nav',
    templateUrl: './custom-side-nav.component.html',
    styleUrl: './custom-side-nav.component.scss',
    standalone: true,
    animations: [
        trigger('expandContractNavBar', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateX(-100%)' }),
                animate('0.5s ease-in-out', style({ opacity: 1, transform: 'translateX(0%)' }))
            ]),
            transition(':leave', [
                animate('0.5s ease-in-out', style({ opacity: 0, transform: 'translateX(-100%)' }))
            ])
        ])
    ],
    imports: [CommonModule, MatListModule, NgOptimizedImage, SideNavMenuComponent]
})
export class CustomSideNavComponent implements OnInit{
    fullUserRoleVerticle: any;
    collapsed = signal(false);
    menuItems: any;
    constructor(private ls: LocalStorageService) {
    }
    ngOnInit() {
        this.fullUserRoleVerticle = this.ls.get('fullUserRoleVerticle');
        // console.log(this.fullUserRoleVerticle)
        this.menuItems = signal<IMenuItem[]>([
            {
                label: 'dashboard',
                icon: 'dashboard',
                route: 'myTask'
            },
            {
                label: 'cadreManagement',
                icon: 'cadre-management',
                subItems: [
                    {
                        label: 'profileReview',
                        route: 'profileReview'
                    },
                    {
                        label: "assignedActivity",
                        route: 'activities/list/assigned'
                    },
                    {
                        label: "plannedActivity",
                        route: 'activities/list/planned'
                    },
                    // {
                    //     label: 'payments',
                    //     route: 'payments'
                    // }
                ]
            }, {
                label: 'cadrePayment',
                icon: 'cadre-payment',
                subItems: [
                    {
                        label: 'monthlyPaymentDetails',
                        route: 'cadre-payment/monthly-payment-details'
                    },

                    ...(this.fullUserRoleVerticle?.includes('block-manager') ? [
                        {
                            label: 'reportTracker',
                            route: 'cadre-payment/report-tracker'
                        }
                    ] : [])
                ]

            },
            {
                label: 'cadreRoleConfiguration',
                icon: 'cadre-role-config',
                route: 'cadre-role-configuration'
            },
            {
                label: 'activityConfiguration',
                icon: 'activity-config',
                subItems: [
                    // {
                    //     label: 'categorylist',
                    //     route: 'activityConfiguration/category-list'
                    // },
                    // {
                    //     label: 'subCategorylist',
                    //     route: 'activityConfiguration/sub-category-list'
                    // },
                    {
                        label: 'activityNamelist',
                        route: 'activityConfiguration/activity-name-list'
                    }
                ]
            },
            {
                label: 'master',
                icon: 'master-config',
                subItems: [
                    {
                        label: 'geographyMaster',
                        route: 'master/geography-master'
                    },
                    {
                        label: 'roles',
                        route: 'master/role'
                    },
                    {
                        label: 'vertical',
                        route: 'master/thematic'
                    },
                ]
            },
            {
                label: 'reports',
                icon: 'report-side-nav',
                subItems: [
                    {
                        label: 'cadreProfileSummary',
                        route: 'reports/profile-summary'
                    }
                ]
            },
        ]);
    }


}
